import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import Alert from "./components/ui/alert.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry/sentryInit.ts";
import { FeatureFlagProvider } from "./lib/unleash/FeatureFlagProvider.tsx";

initSentry();
// TODO: Create actual error page for Sentry Error Boundary
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="w-screen h-screen flex justify-center items-center">
          <Alert
            className="w-96"
            title="Unknown Error"
            description="Unknown error"
          />
        </div>
      }
    >
      <HelmetProvider>
        <FeatureFlagProvider>
          <App />
        </FeatureFlagProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
